import { Dispatch, SetStateAction } from 'react';
import IUser from 'types/superadmin/ISuperAdmin';
import { escapeRegExp } from 'utils/helpers';

export const handleGridSearch = (searchTerm: string, users: IUser[], setRows: Dispatch<SetStateAction<IUser[]>>) => {
  if (searchTerm) {
    const searchRegex = new RegExp(escapeRegExp(searchTerm), 'i');
    const filteredRows = users.filter((row: IUser) => {
      return Object.keys(row).some((field: string) => {
        return searchRegex.test(row[field]);
      });
    });
    setRows(filteredRows);
  } else {
    setRows(users);
  }
};
